import moment, { Moment } from 'moment'

export const isListenerMinor = (value: string, today: Moment = moment()) => {
    const birthDate = moment(value, 'DD.MM.YYYY', true)
    if (!birthDate.isValid() || birthDate.isAfter(today, 'day')) return false

    return birthDate.add(18, 'years').isAfter(today, 'day')
}